import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';

import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';

import { CarouselConfig } from 'ngx-bootstrap/carousel';

import { UsersService } from '../../Services/users.service';

enum errorType  {
  'info',
  'success',
  'warning',
  'danger'
}

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  providers: [
    { provide: CarouselConfig, useValue: { interval: 3000, noPause: false, showIndicators: false } }
  ]
})
export class ForgotPasswordComponent implements OnInit {
  @ViewChild("email") emailField: ElementRef;

  emailFormControl = new FormControl('', [
    Validators.required
  ]);

  
  
  isAuthenticating = false;
  errorObject = {
    alertType: errorType.info,
    alertMsg: '',
    showAlert: false
  };
  
  constructor(public afAuth: AngularFireAuth, 
    public db: AngularFireDatabase,
    private router: Router,
    private usersService: UsersService) { }

  ngOnInit() {
    this.emailField.nativeElement.focus();
  }

  sendResetEmail() {
    let email = this.emailFormControl.value;
    this.usersService.sendPasswordResetEmail(email)
    .subscribe((response) => {
      this.router.navigate(['/reset-email-sent']);
    }, (error) => {
      this.errorObject.alertType = errorType.danger;
      this.errorObject.alertMsg = "We could not process your request. Please try later or contact support.";
      this.errorObject.showAlert = true;
    });
  }

  onAlertClosed(alert) {
    this.errorObject.showAlert = false;
  }

}
